import { ORDER_METHODS } from '../../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'toimitus',
    [ORDER_METHODS.PICKUP]: 'nouto',
    [ORDER_METHODS.ROOM_SERVICE]: 'paikan päällä',
  },
  feedback: {
    payment_method_disabled: 'Emme hyväksy {{paymentMethod}}-maksuja {{orderMethod}}-tilauksissa',
    cash_disabled: 'Emme hyväksy käteismaksuja {{orderMethod}}-tilauksissa',
  },
};
